<template>
  <div class="v-check">
    <input
      class="v-check-control"
      type="checkbox"
      :name="name"
      :id="id"
      :value="value"
      :checked="isChecked"
      @input="onInput"
      @change="onChange"
    />
    <label v-if="label" class="v-check-label" :for="id">
      {{ label }}
    </label>
    <slot name="title" />
  </div>
</template>

<script>
export default {
  name: "BaseCheckbox",
  model: {
    prop: "modelValue",
    event: "change"
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    value: {
      type: [Boolean, String],
      default: ""
    },
    uncheckedValue: {
      type: [Boolean, String],
      default: ""
    },
    modelValue: {
      type: [Boolean, String],
      default: ""
    }
  },
  methods: {
    onInput(event) {
      this.$emit("input", event.target.value);
    },
    onChange(event) {
      let isChecked = event.target.checked;
      this.$emit("change", isChecked ? this.value : this.uncheckedValue);
    }
  },
  computed: {
    isChecked() {
      return this.modelValue === true;
    }
  }
};
</script>
